import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["switch", "dot", "monthlyLabel", "annualLabel"]
  static values = {
    annual: { type: Boolean, default: false }
  }

  connect() {
    this.updateDisplay()
  }

  toggle() {
    this.annualValue = !this.annualValue
    this.updateDisplay()
  }

  updateDisplay() {
    // Update toggle switch appearance
    if (this.hasSwitchTarget) {
      if (this.annualValue) {
        this.switchTarget.classList.add("bg-primary-600")
        this.switchTarget.classList.remove("bg-slate-200", "dark:bg-slate-700")
      } else {
        this.switchTarget.classList.remove("bg-primary-600")
        this.switchTarget.classList.add("bg-slate-200", "dark:bg-slate-700")
      }
    }

    // Update toggle dot position
    if (this.hasDotTarget) {
      if (this.annualValue) {
        this.dotTarget.classList.add("translate-x-5")
        this.dotTarget.classList.remove("translate-x-0")
      } else {
        this.dotTarget.classList.remove("translate-x-5")
        this.dotTarget.classList.add("translate-x-0")
      }
    }

    // Update label styling
    if (this.hasMonthlyLabelTarget) {
      if (this.annualValue) {
        this.monthlyLabelTarget.classList.remove("font-semibold", "text-slate-900", "dark:text-slate-50")
        this.monthlyLabelTarget.classList.add("text-slate-600", "dark:text-slate-400")
      } else {
        this.monthlyLabelTarget.classList.add("font-semibold", "text-slate-900", "dark:text-slate-50")
        this.monthlyLabelTarget.classList.remove("text-slate-600", "dark:text-slate-400")
      }
    }

    if (this.hasAnnualLabelTarget) {
      if (this.annualValue) {
        this.annualLabelTarget.classList.add("font-semibold", "text-slate-900", "dark:text-slate-50")
        this.annualLabelTarget.classList.remove("text-slate-600", "dark:text-slate-400")
      } else {
        this.annualLabelTarget.classList.remove("font-semibold", "text-slate-900", "dark:text-slate-50")
        this.annualLabelTarget.classList.add("text-slate-600", "dark:text-slate-400")
      }
    }

    // Update all pricing cards on the page
    this.updatePricingCards()
  }

  // Prices live on the card as data attributes rather than in a map here, so
  // the page is the single source and the two cannot drift apart.
  updatePricingCards() {
    document.querySelectorAll("[data-plan-monthly]").forEach((card) => {
      const monthly = Number(card.dataset.planMonthly)
      const annualTotal = Number(card.dataset.planAnnualTotal)
      const saving = Number(card.dataset.planSaving)

      const amount = card.querySelector("[data-price-amount]")
      const period = card.querySelector("[data-price-period]")
      const note = card.querySelector("[data-annual-savings]")
      if (!amount || !period) return

      // The headline figure is whatever the customer would actually be billed,
      // so choosing annual promotes the annual total rather than burying it.
      if (this.annualValue) {
        amount.textContent = this.money(annualTotal)
        period.textContent = period.dataset.annualPeriod
        // On monthly this is a cross sell the toggle already makes, repeated in
        // every column, so it stays hidden. It keeps its space either way so
        // switching does not shift the row.
        if (note) {
          note.textContent = `You save ${this.money(saving)} a year.`
          note.classList.remove("invisible")
        }
      } else {
        amount.textContent = this.money(monthly)
        period.textContent = period.dataset.monthlyPeriod
        if (note) note.classList.add("invisible")
      }
    })
  }

  money(value) {
    return `$${value.toLocaleString("en-US")}`
  }
}
